var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-content',{staticClass:"scaling-font-small big-btn",class:{ enabled: !_vm.disabled, disabled: _vm.disabled, 'md-elevation-2': !_vm.pressed },on:{"click":function($event){$event.stopPropagation();return _vm.click.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }